import styled from 'styled-components';

interface StyledTextProps {
  $textColor?: string;
}

const StyledText = styled.p<StyledTextProps>`
  color: ${props => props.$textColor || '#000000'};
`

export default StyledText;
